<div class = "shift-address" *ngIf = "shiftAddressList?.length">
  <div class = "general-regular">
    <i class = "fas fa-map-marker"></i><span class = "general-book-bold">Multiple addresses: </span>
    <div *ngFor = "let street of shiftAddressList; let i = index" class = "multi-address">
      <li><span class = "general-book-bold">{{ i + 1 }}.</span>&nbsp;{{street}}</li>
    </div>
  </div>
</div>